module.exports = "tr:hover {\n  background-color: #fbfbfb;\n  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0);\n  cursor: pointer;\n  z-index: 1; }\n"